import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ImagePreview } from './ImagePreview.js';
import { MeetupDetailTable } from './MeetupDetailTable.js';
import { MainBox } from './MainBox.js';
import { SlideShow } from './SlideShow.js';

const ImageDialog = ({
  item
}) => item.slide ? /*#__PURE__*/React.createElement(SlideShow, {
  images: item.slide.paths
}) : item.poster_url ? /*#__PURE__*/React.createElement(ImagePreview, {
  src: item.poster_url,
  alt: 'thumbnail'
}) : /*#__PURE__*/React.createElement(ImagePreview, {
  src: item.image_url,
  alt: 'thumbnail'
}, item.image_credit && /*#__PURE__*/React.createElement(Typography, {
  variant: "body2",
  sx: {
    textAlign: 'center'
  }
}, "Image Credit: ", item.image_credit));
const MeetupPage = ({
  item
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MainBox, {
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 6,
    display: {
      xs: 'none',
      lg: 'block'
    }
  }, /*#__PURE__*/React.createElement(ImageDialog, {
    item: item
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 6,
    sx: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    sx: {
      fontWeight: 'bold',
      mt: 3,
      mb: 3,
      pl: 1
    }
  }, item.title), /*#__PURE__*/React.createElement(MeetupDetailTable, {
    item: item
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    display: {
      xs: 'block',
      lg: 'none'
    }
  }, /*#__PURE__*/React.createElement(ImageDialog, {
    item: item
  })))));
};

export { MeetupPage, MeetupPage as default };
